module.exports = __webpack_public_path__ + "img/17844_S.b3f7832e.png";